import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

let sentryConfigured = false;

const shouldIgnore = event => {
    const data = JSON.stringify(event.exception);

    if ((data || '').indexOf('play() request was interrupted') !== -1) {
        return true;
    }

    if ((data || '').indexOf('SourceBuffer') !== -1) {
        return true;
    }

    if ((data || '').indexOf('Illegal invocation') !== -1) {
        return true;
    }

    if ((data || '').indexOf('InvalidStateError') !== -1) {
        return true;
    }

    if ((data || '').indexOf('cookiebot.com') !== -1) {
        return true;
    }

    return false;
}

const configureSentry = ({ dsn }) => {
    Sentry.init({
        dsn,
        integrations: [
            new Integrations.BrowserTracing(),
        ],
        beforeSend(event) {
            if (shouldIgnore(event)) {
                return null;
            }

            if (!event.exception) {
                return event;
            }

            if (event.extra && event.extra.silent === true) {
                return event;
            }

            // Sentry.showReportDialog({ eventId: event.event_id });

            return event;
        },
    });

    sentryConfigured = true;
}

const emitDataLayer = (exception, category = 'Errors', action = 'Unhandled Exception') => {
    window.dataLayer = window.dataLayer || [];

    const eventData = {
        event: 'CraftEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: exception,
    };

    window.dataLayer.push(eventData);
}

const captureException = exception => {
    const message = exception && exception.message ? exception.message : 'Unknown Error';

    emitDataLayer(message);

    if (!sentryConfigured) {
        return message;
    }

    const { extra, tags, contexts, user, leve, fingerprint } = exception;

    Sentry.captureException(exception, { extra, tags, contexts, user, leve, fingerprint });
}

const captureMessage = (message, category = 'Errors', action = 'Message') => {
    emitDataLayer(message, category, action);

    if (!sentryConfigured) {
        return message;
    }

    Sentry.captureMessage(message);
}

const captureValidationMessage = (message, action = 'Handled Exception') => {
    return captureMessage(
        message,
        'Validation Errors',
        action,
    );
}

const ignoreIfException = async action => {
    try {
        return await action();
    } catch (error) {
        console.error(error);

        return null;
    }
}

const reportIfException = async action => {
    try {
        return await action();
    } catch (error) {
        console.error(error);
        captureMessage(error.message);

        return null;
    }
}

const reportSilently = exception => {
    if (!exception) {
        exception = new Error('Unknown error');
    }

    exception.extra = {
        silent: true,
    }

    captureException(exception);
}

export {
    Sentry,
    emitDataLayer,
    captureMessage,
    reportSilently,
    configureSentry,
    ignoreIfException,
    reportIfException,
    captureValidationMessage,
}

export default captureException;

window.captureMessage = captureMessage;
window.captureException = captureException;
